
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M108.738 27.451a13 13 0 015.092 5.064l71.402 128.158c3.494 6.272 1.243 14.189-5.03 17.683a13 13 0 01-6.326 1.644H31.986c-7.18 0-13-5.82-13-13a13 13 0 011.61-6.265L91.083 32.577c3.46-6.29 11.364-8.586 17.655-5.126zM103 141c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0-86c-5.523 0-10 16.118-10 36s4.477 36 10 36 10-16.118 10-36-4.477-36-10-36z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    